<!--
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-10 11:06:01
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-13 09:39:47
 * @FilePath: \eu-eswop-official-site\src\views\home\components\section6.vue
 * @Description:
-->
<template>
  <div class="section">
    <div v-if="isMaxScreen" class="page pc_page-6">
      <div class="about-top-container">
        <div class="container">
          <div class="about-left-container">
            <div class="about-content">
              <div class="about-content-title-container">
                <div class="about-content-title">
                  {{$t('components.section6.646txzpazuc0')}}
                </div>
              </div>
              <div class="about-content-text">
                {{$t('components.section6.666txzpazuc0')}}
              </div>
            </div>
            <div class="about-content-btn" @click="handleDetail">{{$t('components.section6.646txzpb0rk0')}}</div>
          </div>
          <div class="about-right-container">
            <div class="section-6-image-container" >
              <img :src="isES ? esPcPic : enPcPic" alt="" class="section-6-image" />
            </div>
          </div>
        </div>
      </div>
      <div class="about-bottom-container">
        <div class="about-bottom-left-box">{{$t('components.section6.646txzpb0xc0')}}</div>
        <div class="about-bottom-right-container">
          <div class="about-right-box">
            <div v-for="(brand, i) in brands" :key="i" class="section-6-brand-image-box">
              <img
                :src="brand.url"
                alt=""
                class="section-6-brand-image"
              />
            </div>
          </div>
          <div class="about-right-box" aria-hidden="true">
            <div v-for="(brand, i) in brands" :key="i" class="section-6-brand-image-box">
              <img
                :src="brand.url"
                alt=""
                class="section-6-brand-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="page page-6">
      <div class="about-top-container">
        <div class="about-left-container">
          <div class="about-content">
            <div class="about-content-title">{{$t('components.section6.646txzpazuc0')}}</div>
            <div class="about-content-text">
              {{$t('components.section6.666txzpazuc0')}}
            </div>
          </div>
          <div class="about-content-btn" @click="handleDetail">{{$t('components.section6.646txzpb0rk0')}}</div>
        </div>
        <div class="about-right-container">
          <img :src="isES ? esMbPic : enMbPic" alt="" class="section-6-image" />
        </div>
      </div>
      <div class="about-bottom-container">
        <div class="about-bottom-left-box">{{$t('components.section6.646txzpb0xc0')}}</div>
        <div class="about-bottom-right-container">
          <div class="about-right-box">
            <div v-for="(brand, i) in brands" :key="i" class="section-6-brand-image-box">
              <img
                :src="brand.url"
                alt=""
                class="section-6-brand-image"
              />
            </div>
          </div>
          <div class="about-right-box">
            <div v-for="(brand, i) in brands" :key="i" class="section-6-brand-image-box">
              <img
                :src="brand.url"
                alt=""
                class="section-6-brand-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isES } from '@/locales';
export default {
  name: 'section6',
  components: {},
  data() {
    return {
      esPcPic: require('../../../assets/image/eu-home/es-pc-s6.png'),
      enPcPic: require('../../../assets/image/eu-home/en-pc-s6.png'),
      esMbPic: require('../../../assets/image/eu-home/es-mb-s6.png'),
      enMbPic: require('../../../assets/image/eu-home/en-mb-s6.png'),
      brands: [
        {
          url: require('../../../assets/image/eu-home/icon/logo01.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo02.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo03.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo04.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo05.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo06.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo07.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo08.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo09.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo13.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo28.png')
        },
        {
          url: require('../../../assets/image/eu-home/icon/logo33.png')
        }
      ],
      isES
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  methods: {
    handleDetail(){
      this.$router.push({name: 'WhoAreWe'})
    }
  }
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .pc_page-6 {
      padding-top: 120px;
      width: 100%;
      position: relative;
      overflow: hidden;
      .about-top-container {
        padding-bottom: 80px;
        width: 90%;
        max-width: 1400px;
        margin: auto;
        .container {
          display: grid;
          grid-column-gap: 3.3rem;
          grid-row-gap: 96px;
          grid-template-rows: auto;
          grid-template-columns: 1fr 2fr;
          grid-auto-columns: 1fr;
          .about-left-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            .about-content {
              .about-content-title-container{
                margin-bottom: 100px;
                .about-content-title {
                  position: absolute;
                  color: #252629;
                  font-family: 'PingFang SC';
                  font-size: 64px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 150%; /* 96px */
                }
              }
              .about-content-text {
                color: #8f949d;
                font-family: 'PingFang SC';
                font-size: 32px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 48px */
                margin: 12px 0 48px;
              }
            }
            .about-content-btn {
              align-self: baseline;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 17px 54px;
              border-radius: 56px;
              background: #ff9600;

              color: #fff;
              font-family: 'PingFang SC';
              font-size: 20px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%; /* 30px */
            }
          }
          .about-right-container {
            .section-6-image-container{
              width: 55vw;
              min-width: 1016px;
              position: absolute;
              .section-6-image {
                width: 100%;
              }
            }
          }
        }
      }

      .about-bottom-container {
        width: calc(100% - 80px);
        padding: 40px 0px 40px 80px;
        display: flex;
        align-items: center;
        gap: 40px;
        .about-bottom-left-box {
          flex-shrink: 0;
          width: 238px;
          color: #333;
          font-family: 'PingFang SC';
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }
        .about-bottom-right-container{
          display: flex;
          overflow: hidden;
          flex-grow: 1;

          .about-right-box {
            flex-shrink: 0;
            display: flex;
            gap: 20px;
            animation: brand-scroll 40000ms linear infinite both;
            .section-6-brand-image-box {
              flex-shrink: 0;
              width: 156.279px;
              height: 60px;
              display: flex;
              justify-content: center;
              align-items: center;
              .section-6-brand-image {
                height: 60px;
              }
            }
          }
        }
      }
      @media (min-width: 1921px) {
        .about-top-container{
          .container{
            .about-right-container {
              .section-6-image-container{
                width: 30vw;
              }
            }
          }
        }
      }
    }
  }
  @keyframes brand-scroll {
    0% {
      transform: translate(0);
    }
    100% {
      transform: translate(calc(-100% - 20px));
    }
  }
}
@media (max-width: 980px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .page-6 {
      width: 100%;
      .about-top-container {
        padding: 120px 30px;
        width: calc(100% - 60px);
        display: flex;
        flex-direction: column;
        .about-left-container {
          width: 100%;
          display: flex;
          flex-direction: column;
          .about-content {
            .about-content-title {
              color: #252629;
              font-family: 'PingFang SC';
              font-size: 72px;
              font-style: normal;
              font-weight: 500;
              line-height: 150%;
            }
            .about-content-text {
              color: #8f949d;
              font-family: 'PingFang SC';
              font-size: 28px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              margin: 32px 0;
            }
          }
          .about-content-btn {
            align-self: baseline;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 16px 24px;
            border-radius: 112px;
            background: #ff9600;

            color: #fff;
            font-family: 'PingFang SC';
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 30px */
          }
        }
        .about-right-container {
          width: 100%;
          margin-top: 80px;
          .section-6-image {
            width: 100%;
          }
        }
      }

      .about-bottom-container {
        width: calc(100% - 80px);
        padding: 40px 0px 40px 30px;
        display: flex;
        align-items: center;
        gap: 20px;
        .about-bottom-left-box {
          flex-shrink: 0;
          width: 206px;
          color: #333;
          font-family: 'PingFang SC';
          font-size: 24px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        .about-bottom-right-container{
          display: flex;
          overflow: hidden;
          flex-grow: 1;

          .about-right-box {
            flex-shrink: 0;
            display: flex;
            gap: 20px;
            animation: brand-scroll 40000ms linear infinite both;

            .section-6-brand-image-box {
              width: 166px;
              height: 64px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-shrink: 0;

              .section-6-brand-image {
                height: 64px;
              }
            }
          }
        }
      }
    }
  }
  @keyframes brand-scroll {
    0% {
      transform: translate(0);
    }
    100% {
      transform: translate(calc(-100% - 20px));
    }
  }
}
</style>
